// 教师类型
export const teacherType = [
  { value: 1, label: '超级管理员' },
  { value: 157, label: '系统主管' },
  { value: 155, label: '教务' },
  { value: 156, label: '讲师' },
  { value: 159, label: '运营' },
];

// 学生身份
export const studentIdentity = [
  { value: 1, label: '学生' },
  { value: 2, label: '成人' },
];

// 是否延期
export const isDelay = [
  { value: 0, label: '否' },
  { value: 1, label: '是' },
];

// 是否卡课学生
export const isCard = [
  { value: 0, label: '否' },
  { value: 1, label: '是' },
];

// 课节状态
export const courseStatus = [
  { value: 0, label: '未开始' },
  { value: 2, label: '上课中' },
  { value: 1, label: '已结束' },
];

// 星期一 - 星期日
export const weekDate = [
  { value: 1, label: '星期日' },
  { value: 2, label: '星期一' },
  { value: 3, label: '星期二' },
  { value: 4, label: '星期三' },
  { value: 5, label: '星期四' },
  { value: 6, label: '星期五' },
  { value: 7, label: '星期六' },
];
// 课程类别
export const courseClassify = [
  { value: 1, label: '日语' },
  { value: 2, label: '韩语' },
  { value: 3, label: '雅思' },
  { value: 4, label: '托福' },
  { value: 5, label: '托业' },
];

// 课节类型=> 直播互动课堂,大班直播课
export const courseType = [
  { value: 2, label: '录播课' },
  { value: 3, label: '直播互动课堂' },
  { value: 4, label: '大班直播课' },
];

// 学生状态
export const studentStatus = [
  { value: 1, label: '报名未选课' },
  { value: 2, label: '未开课' },
  { value: 3, label: '已开课' },
  { value: 4, label: '已结课' },
];

// 学生身份
export const teacherLanguage = [
  { value: '日语', label: '日语' },
  { value: '韩语', label: '韩语' },
  { value: '英语', label: '英语' },
];

// 商品课程状态
export const shopCourseStatus = [
  { value: 0, label: '禁用' },
  { value: 1, label: '正常' },
];

// 商品课程费用类型(课程类型)
export const shopCourseType = [
  { value: 0, label: '免费' },
  { value: 1, label: '收费' },
];

// 商品课程归属
export const shopCoursePosition = [
  { value: 1, label: '日语课程' },
  { value: 5, label: '韩语课程' },
  { value: 6, label: '托福课程' },
  { value: 7, label: '雅思课程' },
];

// 讲师
export const teacherResponsibleLanguage = [
  { value: 1, label: '日语' },
  { value: 5, label: '韩语' },
  { value: 6, label: '托福' },
  { value: 7, label: '雅思' },
];

// 快捷时间类型
export const nimbleType = [
  { value: 0, label: '请选择' },
  { value: 1, label: '半年' },
  { value: 2, label: '一年' },
  { value: 3, label: '两年' },
];

// 快捷时间类型
export const adsPosition = [
  { value: 1, label: 'pc首页轮播广告' },
  { value: 2, label: 'wap首页轮播广告' },
];

// 自动开启音视频
export const autoopenav = [
  { value: 1, label: '自动开启音视频' },
  { value: 2, label: '自动开启音频' },
  { value: 3, label: '自动开启视频' },
];

// 是否开启音频
export const autoopenaudio = [
  { value: 1, label: '自动上麦' },
  { value: 0, label: '不自动上麦' },
];

// 是否是旁听生
export const isExternal = [
  { value: 0, label: '否' },
  { value: 1, label: '是' },
];
